import { useTranslation } from 'react-i18next'
import IconNoOrder from '~/assets/images/no-order.svg'
import { StyledEmptyOrder } from './styled'

const EmptyOrder: React.FC = () => {
  const { t } = useTranslation()
  return (
    <StyledEmptyOrder>
      <img src={IconNoOrder} />
      <div className="note">{t('no_orders')}</div>
    </StyledEmptyOrder>
  )
}

export default EmptyOrder
